import { useState, useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import Transactions from '@/pages/Transactions';
import Categories from '@/pages/Categories';
import Products from '@/pages/Products';
import ProductCategories from '@/pages/ProductCategories';
import Marketplaces from '@/pages/Marketplaces';
import SupplierDeadlines from '@/pages/SupplierDeadlines';
import Layout from '@/components/layout/Layout';
import { Toaster } from '@/components/ui/sonner';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    setIsAuthenticated(!!token);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/transactions"
            element={
              <ProtectedRoute>
                <Layout>
                  <Transactions />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/categories"
            element={
              <ProtectedRoute>
                <Layout>
                  <Categories />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/products"
            element={
              <ProtectedRoute>
                <Layout>
                  <Products />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/product-categories"
            element={
              <ProtectedRoute>
                <Layout>
                  <ProductCategories />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/marketplaces"
            element={
              <ProtectedRoute>
                <Layout>
                  <Marketplaces />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/supplier-deadlines"
            element={
              <ProtectedRoute>
                <Layout>
                  <SupplierDeadlines />
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
